/*!
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { Permission } from '@nextcloud/files';
/**
 * Check permissions on the node if it can be downloaded
 *
 * @param node The node to check
 * @return True if downloadable, false otherwise
 */
export function isDownloadable(node) {
    if ((node.permissions & Permission.READ) === 0) {
        return false;
    }
    // check hide-download property of shares
    if (node.attributes['hide-download'] === true
        || node.attributes['hide-download'] === 'true') {
        return false;
    }
    // If the mount type is a share, ensure it got download permissions.
    if (node.attributes['share-attributes']) {
        const shareAttributes = JSON.parse(node.attributes['share-attributes'] || '[]');
        const downloadAttribute = shareAttributes.find(({ scope, key }) => scope === 'permissions' && key === 'download');
        if (downloadAttribute !== undefined) {
            return downloadAttribute.value === true;
        }
    }
    return true;
}
/**
 * Check permissions on the node if it can be synced/open locally
 *
 * @param node The node to check
 * @return True if syncable, false otherwise
 */
export function isSyncable(node) {
    if (!node.isDavResource) {
        return false;
    }
    if ((node.permissions & Permission.WRITE) === 0) {
        return false;
    }
    // Syncable has the same permissions as downloadable for now
    return isDownloadable(node);
}
